import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { updateArray } from '../helpers/InvestmentProductsHelper.js'
import { ProductContext } from '../ProductContext.jsx'

export default function ModelPortfoliosFilter({
  selectedClass,
  onChange,
  onClose,
  selectedFilter,
}) {
  const [selectedTypes, setSelectedTypes] = useState(
    selectedFilter?.types || []
  )
  const [selectedCategories, setSelectedCategories] = useState(
    selectedFilter?.categories || []
  )
  const [selectedGoals, setSelectedGoals] = useState(
    selectedFilter?.goals || []
  )
  const { isMobile } = useContext(ProductContext)

  const onChangeTypeCheckbox = (event) => {
    updateArray(selectedTypes, event.target.value, event.target.checked)

    setSelectedTypes(selectedTypes)

    onChange &&
      onChange({
        types: selectedTypes,
        categories: selectedCategories,
        goals: selectedGoals,
      })
  }

  const onChangeCategoryCheckbox = (event) => {
    updateArray(selectedCategories, event.target.value, event.target.checked)

    setSelectedCategories(selectedCategories)

    onChange &&
      onChange({
        types: selectedTypes,
        categories: selectedCategories,
        goals: selectedGoals,
      })
  }

  const onClickViewResults = () => {
    onClose && onClose()
  }

  const onClickClearFilters = () => {
    setSelectedTypes([])
    setSelectedCategories([])
    setSelectedGoals([])

    onChange && onChange({ types: [], categories: [], goals: [] })
  }

  return (
    <>
      {isMobile ? (
        <div className="Accordion Accordion--ruled u-paddingHoriz2gu u-overflowY">
          <div className="u-marginBottom4gu u-flex u-flexJustifyBetween">
            <p className="u-textColorBrandDark u-textBold">
              Filters (
              {selectedCategories.length +
                selectedGoals.length +
                selectedTypes.length}{' '}
              Applied)
            </p>
            {/* eslint-disable-next-line jsx-a11y/no-redundant-roles -- CTINEXT-4711 */}
            <button
              type="button"
              onClick={() => onClose && onClose()}
              className="adel-material-symbols-14"
              // eslint-disable-next-line jsx-a11y/no-redundant-roles
              role="button"
              aria-label="Close"
            >
              <span aria-hidden="true">X</span>
              <span className="u-hiddenVisually">Close</span>
            </button>
          </div>
          <details className="Accordion-item u-paddingVert2gu">
            <summary className="Accordion-toggle u-paddingVert2gu">
              Risk Tolerance
            </summary>
            <div>
              {selectedClass &&
                selectedClass.filterInfo.length > 0 &&
                selectedClass.filterInfo.find(
                  (filter) => filter.filterName === 'Risk Tolerance'
                ) &&
                selectedClass.filterInfo
                  .find((filter) => filter.filterName === 'Risk Tolerance')
                  .filterValues.map((fundClassFilter) => {
                    return (
                      <div key={fundClassFilter.code} className="Checkbox">
                        <input
                          type="checkbox"
                          id={
                            'fundClass' +
                            fundClassFilter.code +
                            'Mobile-Checkbox'
                          }
                          className="Checkbox-button"
                          checked={
                            selectedTypes.indexOf(fundClassFilter.code) > -1
                          }
                          value={fundClassFilter.code}
                          onChange={onChangeTypeCheckbox}
                        />
                        <label
                          htmlFor={
                            'fundClass' +
                            fundClassFilter.code +
                            'Mobile-Checkbox'
                          }
                          className="Checkbox-label u-margin0"
                        >
                          <div className="u-textNoWrap">
                            {fundClassFilter.desc}
                          </div>
                        </label>
                      </div>
                    )
                  })}
            </div>
          </details>
          <details className="Accordion-item u-paddingVert2gu">
            <summary className="Accordion-toggle u-paddingVert2gu">
              Implementation Style
            </summary>
            <div>
              {selectedClass &&
                selectedClass.filterInfo.length > 0 &&
                selectedClass.filterInfo.find(
                  (filter) => filter.filterName === 'Investment Recommendation'
                ) &&
                selectedClass.filterInfo
                  .find(
                    (filter) =>
                      filter.filterName === 'Investment Recommendation'
                  )
                  .filterValues.sort((a, b) => a.desc.localeCompare(b.desc))
                  .map((implementType) => {
                    return (
                      <div
                        key={implementType.code}
                        className="u-flex u-flexAlignItemsCenter"
                      >
                        <div className="Checkbox">
                          <input
                            type="checkbox"
                            id={
                              'investmentCategory' +
                              implementType.code +
                              'Mobile-Checkbox'
                            }
                            className="Checkbox-button"
                            checked={
                              selectedCategories.indexOf(
                                implementType.code.toString()
                              ) > -1
                            }
                            value={implementType.code}
                            onChange={onChangeCategoryCheckbox}
                          />
                          <label
                            htmlFor={
                              'investmentCategory' +
                              implementType.code +
                              'Mobile-Checkbox'
                            }
                            className="Checkbox-label u-margin0"
                          >
                            <div className="u-textNoWrap">
                              {implementType.desc}
                            </div>
                          </label>
                        </div>
                      </div>
                    )
                  })}
            </div>
          </details>
        </div>
      ) : (
        <div className="Grid Grid--withGutter u-paddingVert1gu u-paddingHoriz7gu">
          <div className="u-size6of12 u-sm-sizeFull">
            <h4 className="u-textSizeMsrp1 u-textBold MutualFunds-filterTitle u-textColorBrandDark">
              Risk Tolerance
            </h4>
            <div>
              {selectedClass &&
              selectedClass.filterInfo.length > 0 &&
              selectedClass.filterInfo.find(
                (filter) => filter.filterName === 'Risk Tolerance'
              )
                ? selectedClass.filterInfo
                    .find((filter) => filter.filterName === 'Risk Tolerance')
                    .filterValues.map((fundClassFilter) => {
                      return (
                        <div key={fundClassFilter.code} className="Checkbox">
                          <input
                            type="checkbox"
                            id={'fundClass' + fundClassFilter.code + 'Checkbox'}
                            className="Checkbox-button"
                            checked={
                              selectedTypes.indexOf(fundClassFilter.code) > -1
                            }
                            value={fundClassFilter.code}
                            onChange={onChangeTypeCheckbox}
                          />
                          <label
                            htmlFor={
                              'fundClass' + fundClassFilter.code + 'Checkbox'
                            }
                            className="Checkbox-label u-margin0"
                          >
                            <div className="u-textNoWrap">
                              {fundClassFilter.desc}
                            </div>
                          </label>
                        </div>
                      )
                    })
                : null}
            </div>
          </div>
          <div className="u-size6of12 u-sm-sizeFull">
            <h4 className="u-textSizeMsrp1 u-textBold MutualFunds-filterTitle u-sm-marginTop6gu u-textColorBrandDark">
              Implementation Style
            </h4>
            <div>
              {selectedClass &&
              selectedClass.filterInfo.length > 0 &&
              selectedClass.filterInfo.find(
                (filter) => filter.filterName === 'Investment Recommendation'
              )
                ? selectedClass.filterInfo
                    .find(
                      (filter) =>
                        filter.filterName === 'Investment Recommendation'
                    )
                    .filterValues.sort((a, b) => a.desc.localeCompare(b.desc))
                    .map((implementType) => {
                      return (
                        <div
                          key={implementType.code}
                          className="u-flex u-flexAlignItemsCenter"
                        >
                          <div className="Checkbox">
                            <input
                              type="checkbox"
                              id={
                                'investmentCategory' +
                                implementType.code +
                                'Checkbox'
                              }
                              className="Checkbox-button"
                              checked={
                                selectedCategories.indexOf(
                                  implementType.code.toString()
                                ) > -1
                              }
                              value={implementType.code}
                              onChange={onChangeCategoryCheckbox}
                            />
                            <label
                              htmlFor={
                                'investmentCategory' +
                                implementType.code +
                                'Checkbox'
                              }
                              className="Checkbox-label u-margin0"
                            >
                              <div className="u-textNoWrap">
                                {implementType.desc}
                              </div>
                            </label>
                          </div>
                        </div>
                      )
                    })
                : null}
            </div>
          </div>
        </div>
      )}
      <div className="InvestmentProductsFilterButtons u-sm-flex u-sm-paddingHoriz0 u-paddingVert4gu u-paddingHoriz7gu">
        <button
          className="Button Button--primary Button--small"
          data-tracking="view-results"
          onClick={onClickViewResults}
        >
          VIEW RESULTS
        </button>
        <button
          className="Button Button--tertiary Button--small u-marginLeft3gu"
          data-tracking="clear-filters"
          onClick={onClickClearFilters}
        >
          CLEAR FILTERS
        </button>
      </div>
    </>
  )
}
ModelPortfoliosFilter.propTypes = {
  selectedFilter: PropTypes.object,
  selectedClass: PropTypes.object,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  lookupCategory: PropTypes.func,
}
